<template>
  <v-container class="p-insure px-0">
    <v-layout>
      <Stepper :value="1" class="stepper"></Stepper>
    </v-layout>
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="投保" class="insure-card">
          <h3>美亚和顺保-团体意外伤害保险</h3>
          <v-form ref="form" lazy-validation class="form">
            <!-- 企业信息 -->
            <section class="form-section">
              <p class="mb-4">投保人信息</p>
              <v-layout>

                <div class="form-item">
                  <label><span class="must-tap">*</span>企业名称</label>
                  <v-text-field style="width:300px" v-model="form.companyName" :solo="solo" :rules="rules.companyName"></v-text-field>
                </div>
                <v-flex class="form-item form-item-left">
                  <label><span class="must-tap">*</span>企业续存时间</label>
                  <v-select
                    v-model="form.applicantEEstablishTime"
                    :items="companyTIme"
                    :rules="rules.applicantEEstablishTime"
                    :solo="solo"
                    label
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label><span class="must-tap">*</span>企业证件号</label>
                  <v-select
                    v-model="form.companyCardType"
                    :items="companyCardTypies"
                    :solo="solo"
                    label
                  ></v-select>
                </v-flex>
                <v-flex class="form-item">
                  <v-text-field
                    v-model="form.companyCardNo"
                    :solo="solo"
                    :rules="rules.companyCardNo"
                    label
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="form-item-btn-mb">
                <v-flex class="form-item form-item-left">
                  <label><span class="must-tap">*</span>营业执照</label>
                  <CUpload
                    class="form-item-btn-wrap"
                    :on-success="onUploadSuccess"
                    show-type="picture"
                    :limit="1"
                  >上传营业执照</CUpload>
                </v-flex>
                <v-flex class="form-item">
                  <a class="primary-text mt-2" @click="sampleVisible = true">查看样例</a>
                </v-flex>
              </v-layout>
              <v-layout>
                <div class="form-item">
                  <label><span class="must-tap">*</span>企业所在地</label>
                  <v-combobox
                    v-model="form.applicantEProvince"
                    :items="areaList"
                    :rules="rules.applicantEProvince"
                    :solo="solo"
                    label
                  ></v-combobox>
                </div>
                <v-flex class="form-item">
                  <label><span class="must-tap">*</span>企业性质</label>
                   <v-select
                    v-model="form.applicantEInstitutionType"
                    :items="companyNature"
                    :rules="rules.applicantEInstitutionType"
                    :solo="solo"
                    label
                  ></v-select>
                </v-flex>
              </v-layout>
               <div class="form-item">
                <label><span class="must-tap">*</span>企业详细地址</label>
                <v-text-field v-model="form.applicantEAddress" :solo="solo" :rules="rules.applicantEAddress"></v-text-field>
              </div>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label><span class="must-tap">*</span>联系人姓名</label>
                  <v-text-field v-model="form.contactName" :solo="solo" :rules="rules.contactName"></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label><span class="must-tap">*</span>联系电话</label>
                  <v-text-field
                    v-model="form.contactPhoneNumber"
                    :solo="solo"
                    :rules="rules.contactPhoneNumber"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div class="form-item">
                <label><span class="must-tap">*</span>联系邮箱</label>
                <v-text-field v-model="form.contactEmail" :solo="solo" :rules="rules.contactEmail"></v-text-field>
              </div>
            </section>
            <hr class="line">
            <!-- 投保信息 -->
            <section class="form-section">
              <p class="mb-4">投保信息</p>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label><span class="must-tap">*</span>生效日期</label>
                  <!-- 只能选择明天-明天30天以内的时间 -->
                  <v-menu
                    ref="dateMenu"
                    v-model="effectBeginDateMenuVisible"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      class="date-input"
                      v-model="form.effectBeginDate"
                      :solo="solo"
                      :rules="rules.effectBeginDate"
                      append-icon="calendar_today"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="form.effectBeginDate"
                      :header-date-format="date=>date"
                      :min="minEffectBeginDate"
                      :max="maxDate"
                      no-title
                      @input="effectBeginDateMenuVisible = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex class="form-item">
                  <label><span class="must-tap">*</span>保障期限</label>
                  <v-select v-model="form.effectDuration" :items="effectDurationList" :solo="solo"></v-select>
                </v-flex>
              </v-layout>
              <v-layout class="form-item-btn-mb">
                <v-flex class="form-item form-item-left">
                  <label><span class="must-tap">*</span>投保员工</label>
                  <div class="form-item-btn-wrap">
                    <v-btn
                      class="form-item-btn"
                      color="primary"
                      block
                      @click="employeeManageVisible = true"
                    >{{ employees.length === 0?"填写员工信息":"修改员工信息" }}</v-btn>
                  </div>
                </v-flex>
                <v-flex class="form-item">
                  <v-layout
                    v-show="employees.length > 0"
                    align-center
                    fill-height
                  >员工总数：{{ employees.length }}</v-layout>
                </v-flex>
                <v-flex class="form-item form-item-left">
                  <a class="primary-text mt-2" @click="planImg = true">查看方案</a>
                </v-flex>
              </v-layout>
              <InsurancePlanTable
                v-model="form.amount"
                :employees="employees"
                :code="'2016'"
                :plan-id="form.productPlanId"
                :effect-duration="form.effectDuration"
                :plan-list.sync="planList"
              ></InsurancePlanTable>
            </section>
            <aig-birthday-table
                    v-if="birthdayWarningCount > 0"
                    :data="birthdayWarningData"
                    :code="2016"
            />
            <hr class="line">
              <p style="text-align:right;font-size:12px;color:#dd122a;margin-right:160px"><span class="must-tap">*</span>修改投保计划时请在清单中进行修改后重新上传</p>
            <section class="form-section" v-if="payType==0">
              <p class="mb-4">支付前确认<span class="must-tap">(当线上支付时此表单为必填)</span></p>
              <v-container>
                <div class="detail-card-text">
                  <p>本公司/单位确认：</p>
                  <p>本保险合同保费是否由投保人<span class="font-primary">{{ form.companyName }}</span>企业账户支付？</p>
                  <v-flex class="form-item form-item-center">
                    <v-radio-group v-model="companyPayCollection.form.isCompanyPay" row class="form-item-center-radio">
                      <v-radio
                              v-for="(item, key) in companyPayCollection.radioMap"
                              :key="key"
                              :label="item.label"
                              :value="item.value"
                              class="form-item-center-radio-item"
                      />
                    </v-radio-group>
                  </v-flex>
                </div>
                <v-container class="v-container-form">
                  <v-form
                          ref="companyPayCollectionForm"
                          v-model="companyPayCollection.valid"
                          lazy-validation
                  >
                    <div :style="companyPayCollection.form.isCompanyPay == 1 ? 'display:none' : 'display:block'">
                      <v-flex class="form-item">
                        <label><span class="must-tap">*</span>付款人姓名</label>
                        <v-text-field v-model="companyPayCollection.form.payName" :solo="true" :rules="companyPayCollection.rules.name" />
                      </v-flex>
                      <v-flex class="form-item">
                        <label><span class="must-tap">*</span>账号</label>
                        <v-text-field
                                v-model="companyPayCollection.form.payAccount"
                                :solo="true"
                                :rules="companyPayCollection.rules.account"
                                placeholder="请填写银行账户；若使用微信或支付宝余额付款，请填写“微信/支付宝余额付款”"
                        />
                      </v-flex>
                      <v-flex class="form-item">
                        <label><span class="must-tap">*</span>代付款原因</label>
                        <v-text-field
                                v-model="companyPayCollection.form.payAgentReason"
                                :solo="true"
                                :rules="companyPayCollection.rules.reason"
                                placeholder="例：公司同意"
                        />
                      </v-flex>
                      <v-flex class="form-item">
                        <label style="margin-top: -4px">
                          <span class="must-tap">*</span>付款人与投保人企业关系</label>
                        <v-text-field
                                v-model="companyPayCollection.form.payRelation"
                                :solo="true"
                                :rules="companyPayCollection.rules.payRelation"
                                placeholder="例：员工"
                        />
                      </v-flex>
                      <p>本人确认已获得上述投保企业授权支付保费、若发生退费，原路返还至交款账户。</p>
                    </div>
                  </v-form>
                </v-container>
              </v-container>
            </section>
            <section class="form-section">
              <p class="mb-4">保险条款</p>
              <v-flex>
                <a
                  v-for="item in insureLawList"
                  :key="item.name"
                  :href="item.url"
                  class="d-block"
                  target="_blank"
                >{{ '《' + item.name + '》' }}</a>
              </v-flex>
            </section>

          </v-form>
        </CSection>
      </v-flex>
      <template v-if="this.isUseApply === true">
      <v-flex shrink class="right-section">
        <div v-pin="{padding: {top: 136}}" class="pay-card block">
          <div>
            总保费
            <span class="display-1 primary-text">￥{{ form.amount.toFixed(2) }}</span>
          </div>
          <hr class="line">
          <v-flex class="notice-div">
              <a class="notice-p primary-text" @click="healthVisible = true,noticeType = 0,nopayFlg=1">《投保须知》</a>
              <a class="notice-p primary-text" @click="healthVisible = true,noticeType = 1,nopayFlg=1">《责任免除》</a>
              <a class="notice-p primary-text" @click="healthVisible = true,noticeType = 2,nopayFlg=1">《投保前提条件告知》</a>
              <a class="notice-p primary-text" @click="healthVisible = true,noticeType = 3,nopayFlg=1">《投保人声明及确认》</a>
              <a class="notice-p primary-text" @click="healthVisible = true,noticeType = 4,nopayFlg=1">《保险经纪服务授权委托书》</a>
              <a class="notice-p primary-text" @click="healthVisible = true,noticeType = 5,nopayFlg=1">《客户告知书》</a>
            <div class="check-box-div">
              <v-checkbox v-model="form.agree" class="checkbox" label></v-checkbox>
              <p>我已仔细阅读且确认上述内容</p>
            </div>
          </v-flex>
          <hr class="line">
          <div>
            选择支付方式<span>（一经选择，无法修改）</span>
            <v-radio-group row v-model="payType">
              <v-radio label="在线支付" :value="0"></v-radio>
              <v-radio label="线下转账" :value="1"></v-radio>
            </v-radio-group>
          </div>
          <p class="introduce-text attention">提示：保单最早生效日为保费到账后的T+1天，保险起期前保费未到账，保单将会失效</p>
          <v-btn
            class="pay-btn"
            :disabled="!form.agree"
            :loading="loading"
            color="primary"
            block
            @click="onPay"
          >去支付</v-btn>
        </div>
      </v-flex>
      </template>
    </v-layout>
    <v-dialog v-model="planImg" width="900">
      <v-card>
        <v-img src="https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/plan.png"></v-img>
      </v-card>
    </v-dialog>
    <Sample v-model="sampleVisible"></Sample>

    <EmployeeManage
            v-model="employees"
            :visible.sync="employeeManageVisible"
            :effectBeginDate.sync="form.effectBeginDate"
            @warningData="waringData"
    />
    <Notice v-model="noticeVisible"></Notice>
    <TKDialog v-model="tkVisible" code="2016"></TKDialog>
    <Health @changeType="typeChange" :type="noticeType" :isnoPay="nopayFlg" v-model="healthVisible"></Health>
    <DialogAttention v-model="dialogAttentionVisible"/>
  </v-container>
</template>

<script>
// import { record } from "rrweb";
let events = [];
import Stepper from "./components/Stepper";
import InsurancePlanTable from "@/components/Order/aigInsureTable";
import EmployeeManage from "@/components/Order/aigEmploy";
import Sample from "./components/BusinessLicenseSample";
import Notice from "./components/Notice";
import Health from "./components/AigNotice";
import TKDialog from "./components/TKDialog";
import areaList from '@/assets/js/area';
import validate from "@/assets/js/validate";
import DialogAttention from "./components/DialogAttention";
import aigBirthdayTable from "../../components/Order/aigBirthdayTable";

export default {
  components: {
    DialogAttention,
    Stepper,
    InsurancePlanTable,
    EmployeeManage,
    Sample,
    Notice,
    Health,
    TKDialog,
    aigBirthdayTable
  },
  props: {
    code: String
  },
  data() {
    return {
      payType:0,
      nopayFlg:1,
      noticeType:0,
      insureLawList:[
        {name:'美亚附加不承保特定医院条款（2021年第二版）',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E4%B8%8D%E6%89%BF%E4%BF%9D%E7%89%B9%E5%AE%9A%E5%8C%BB%E9%99%A2%E6%9D%A1%E6%AC%BE%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%BA%8C%E7%89%88%EF%BC%89.pdf'},
        {name:'美亚附加经济制裁责任免除条款',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E7%BB%8F%E6%B5%8E%E5%88%B6%E8%A3%81%E8%B4%A3%E4%BB%BB%E5%85%8D%E9%99%A4%E6%9D%A1%E6%AC%BE.pdf'},
        {name:'美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E7%89%B9%E5%AE%9A%E8%81%8C%E4%B8%9A%E7%B1%BB%E5%88%AB%E4%BA%BA%E5%91%98%E9%AB%98%E5%A4%84%E4%BD%9C%E4%B8%9A%E6%9D%A1%E6%AC%BE%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%BA%8C%E7%89%88%EF%BC%89%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E4%B8%93%E5%B1%9E%EF%BC%89.pdf'},
        {name:'美亚附加特种作业限制条款（2021年第二版）（互联网专属）',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E7%89%B9%E7%A7%8D%E4%BD%9C%E4%B8%9A%E9%99%90%E5%88%B6%E6%9D%A1%E6%AC%BE%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%BA%8C%E7%89%88%EF%BC%89%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E4%B8%93%E5%B1%9E%EF%BC%89.pdf'},
        {name:'美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E6%AF%8F%E6%97%A5%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E5%9B%A2%E4%BD%93%E6%94%B6%E5%85%A5%E4%BF%9D%E9%9A%9C%E4%BF%9D%E9%99%A9%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%B8%80%E7%89%88%EF%BC%89.pdf'},
        {name:'美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E5%8C%BB%E8%8D%AF%E8%A1%A5%E5%81%BF%E5%9B%A2%E4%BD%93%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%BA%94%E7%89%88%EF%BC%89%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E4%B8%93%E5%B1%9E%EF%BC%89.pdf'},
        {name:'美亚团体意外伤害保险（2021年第一版）（互联网专属）',url:'https://qihuibao.oss-cn-beijing.aliyuncs.com/aig/aigInsure/%E7%BE%8E%E4%BA%9A%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%882021%E5%B9%B4%E7%AC%AC%E4%B8%80%E7%89%88%EF%BC%89%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E4%B8%93%E5%B1%9E%EF%BC%89.pdf'},
      ],
      planImg:false,
      areaList:areaList,
      solo: true,
      companyTIme:[
        {text:'三年以下',value:15832},
        {text:'三年及以上',value:15833},
      ],
      companyCardTypies: [
        { text: "统一社会信用代码", value: 4 },
        // { text: "海外客户或特殊企业", value: 37006 },
      ],
      companyNature: [
        { text: "国家机关", value: 15827 },
        { text: "国有事业单位", value: 15828 },
        { text: "国有企业", value: 15829 },
        { text: "国有上市公司", value: 15830 },
        { text: "其他", value: 15831 },
      ],
      effectDurationList: [
        { text: "1年", value: 12 },
        { text: "10个月", value: 10 },
        { text: "9个月", value: 9 },
        { text: "8个月", value: 8 },
        { text: "7个月", value: 7 },
        { text: "6个月", value: 6 },
        { text: "5个月", value: 5 },
        { text: "4个月", value: 4 },
        { text: "3个月", value: 3 },
        { text: "2个月", value: 2 },
        { text: "1个月", value: 1 }
      ],
      formValid: true,
      form: {
        applicantEInstitutionType:"",
        applicantEEstablishTime:"",
        applicantEAddress:"",
        applicantEProvince:"",
        companyName: "",
        companyCardType: 4,
        companyCardNo: "",
        contactName: "",
        contactPhoneNumber: "",
        contactEmail: "",
        // 生效日期
        effectBeginDate: "",
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        agree: false,
        amount: 0,
        // 营业执照图片文件
        businessLicenseFile: null
      },
      rules: {
        companyName: [v => !!v || "请输入企业名称",v=>{
          if(v.indexOf("建筑劳务") == -1) {
            if (v.indexOf('人力') != -1 || v.indexOf('劳务') != -1) {
              return "人力资源及劳务派遣公司不可投保"
            }
          }
          return true
        }],
        applicantEProvince: [v => !!v || "请选择企业所在地"],
        applicantEAddress:[v => !!v || "请输入企业详细地址"],
        applicantEEstablishTime:[v => !!v || "请选择企业续存时间"],
        applicantEInstitutionType: [v => !!v || "请输入企业性质"],
        companyCardNo: [
          v => !!v || "请输入对应的证件号",
          v => {
            if (this.form.companyCardType === 1) {
              return (
                validate.isOrganizationCode(v) || "请输入正确的组织机构代码"
              );
            } else if (this.form.companyCardType === 2) {
              return (
                validate.isTaxRegistrationCertificate(v) ||
                "请输入正确的税务登记证"
              );
            } else if (this.form.companyCardType === 3) {
              return validate.isBusinessLicense(v) || "请输入正确的营业执照";
            }
            return (
              validate.isUnifiedSocialCreditCode(v) ||
              "请输入正确的统一社会信用代码"
            );
          }
        ],
        contactName: [
          v => {
            if (!v) {
              return "请输入联系人姓名";
            }
            if (!validate.isChineseName(v)) {
              return "请输入联系人中文姓名";
            }
            return true;
          }
        ],
        contactPhoneNumber: [
          v => {
            if (!v) {
              return "请输入联系电话";
            }
            if (!validate.isTelephone(v) && !validate.isMobilePhone(v)) {
              return "请输入正确的联系电话";
            }
            return true;
          }
        ],
        contactEmail: [
          v => {
            if (!v) {
              return "请输入联系邮箱";
            }
            if (!validate.isEmail(v)) {
              return "请输入正确的联系邮箱";
            }
            return true;
          }
        ],
        effectBeginDate: [v => !!v || "请选择生效日期"]
      },
      // 生效日期选择菜单是否可见
      effectBeginDateMenuVisible: false,
      // 最小生效日期 T+3
      minEffectBeginDate: "",
      // 控制营业执照样例显示
      sampleVisible: false,
      noticeVisible: false,
      tkVisible: false,
      healthVisible: false,
      // 控制员工管理显示
      employeeManageVisible: false,
      employees: [],
      //保障方案列表,由 Plan 组件实时传递
      planList: [],
      loading: false,
      maxDate:'',
      monitorCode:'',
      rrweb:'',
      dialogAttentionVisible:true,
      orderCode:"",
      //支付前确认信息
      companyPayCollection:{
        form : {
          isCompanyPay: 0,
          payName: "",
          payAccount: "",
          payAgentReason: "",
          payRelation: "",
          policyType: "policy"
        },
        rules: {
          name: [v => !!v || "请输入付款人姓名"],
          account: [v => !!v || "请输入账号"],
          reason: [v => !!v || "请输入代付款原因"],
          payRelation: [v => !!v || "请输入付款人与投保企业关系"],
        },
        radioMap:[
          {label:"是", value: 1},
          {label:"否", value: 0},
        ],
        valid:true
      },
      //是否有大于65周岁的数据
      birthdayWarningCount: 0,
      birthdayWarningData: [],
      isUseApply: true
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.$router.push({
      path:'/insure/2017'
    });
    this.$store.dispatch("getUserInfo");
    this.form.effectBeginDate = this.minEffectBeginDate = this.$miment()

      .add(1, "DD")
      .format("YYYY-MM-DD");
    this.maxDate = this.getNewData(this.form.effectBeginDate,59)
    if (process.env.NODE_ENV === "development") {
      // 测试信息
      this.form = {
        companyName: "易才宏业保险经纪有限公司",
        companyCardType: 4,
        companyCardNo: "91120103MA06J25628",
        contactName: "盖伦",
        contactPhoneNumber: "010-88888888",
        contactEmail: "xiaoliang.li@chinatalentgroup.com",
        applicantEEstablishTime:15832,
        applicantEProvince:{text:"中国-北京市-朝阳区",value:35453},
        applicantEAddress:"易才集团",
        applicantEInstitutionType:15827,
        // 生效日期
        effectBeginDate: this.minEffectBeginDate,
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        agree: false,
        amount: 0
      };
      this.employees = [
        {
          name: "包婷珊",
          idCard: "513436200005306058",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1,
            planName:'计划一',
            planId:277
          }
        },
        {
          name: "储庆妹",
          idCard: "51343620000530647X",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1,
            planName:'计划一',
            planId:277
          }
        },
        {
          name: "皇甫国言",
          idCard: "513436200005308811",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1,
            planName:'计划一',
            planId:277
          }
        },
        {
          name: "蔡聪",
          idCard: "513436200005306330",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1,
            planName:'计划一',
            planId:277
          }
        },
        {
          name: "欧仪",
          idCard: "513436200005309734",
          phone: "13488805128",
          category: {
            code: "0104002",
            name: "企业单位职员(内勤)",
            level: 1,
            planName:'计划一',
            planId:277
          }
        }
      ];
    }
  },
  mounted(){
    this.getMonitorCode()
    // record({
    //   emit(event) {
    //     events.push(event);
    //   }
    // });
    // save 函数用于将 events 发送至后端存入，并重置 events 数组
    const save = () => {
      let db = this.rrweb;
      if (db) {
        db = JSON.parse(db);
      } else {
        db = [];
      }
      db = db.concat(events);
      events = [];
      if(db){
        this.rrweb = JSON.stringify(db)
      }
    };
    // 每 10 秒调用一次 save 方法，避免请求过多
    setInterval(save, 3 * 1000);
    const endTime = new Date("2022-06-20 22:00:00").getTime();
    const currentTime = new Date().getTime();
    if (currentTime > endTime){
      this.isUseApply = false
    }
  },
  methods: {
    getMonitorCode(){
      this.$vAxios.get('/reception/getMonitorCode').then(res=>{
        if (res.data) {
          this.monitorCode = res.data;
        }
      })
    },
    getNewData(dateTemp, days) {
      var newdateTemp = dateTemp.split("-"); //格式必须是2020-01-02;
      var nnDate = newdateTemp[1] + '-' + newdateTemp[2] + '-' + newdateTemp[0]; //转换为MM-DD-YYYY格式
      var nDate = new Date(nnDate.replace(/\s+/g, "")); //这一步如果没有空格的话可以省略
      var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
      var rDate = new Date(millSeconds);
      var year = rDate.getFullYear();
      var month = rDate.getMonth() + 1;
      if (month < 10)
      month = "0" + month;
      var date = rDate.getDate();
      if (date < 10) date = "0" + date;
      return (year + "-" + month + "-" + date);
    },
    onPay() {
      if (this.$refs.form.validate()) {
        if (!(this.form.businessLicenseFile instanceof File)) {
          this.$message.error("请上传营业执照");
          return false;
        }
        if (this.employees.length < 3) {
          this.$message.error("员工人数至少需要3人，请修改后重新提交");
          return false;
        }
        if (this.payType == 0 && this.companyPayCollection.form.isCompanyPay == 0){
          if (!this.$refs.companyPayCollectionForm.validate()){
            return false;
          }
        }
        this.noticeType = 0
        this.nopayFlg = 0
        this.healthVisible = true;
      }
    },
    typeChange(val){
      if(val === 'canpay'){
        this.healthVisible = false;
        this.loading = true;
        const entity = this.transformToEntity();
        let formData = new FormData();
        formData.append("policyJson", JSON.stringify(entity));
        formData.append("file", this.form.businessLicenseFile);

        this.$axios
          .post("/app/api/heshunbao/submitPolicy", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(res => {
            this.orderCode = res.data.orderCode;
            if (this.payType == 1) {
              this.videoSave(res)
              this.loading = false;
            }else{
              //this.isCompanyPay = true;
              this.companyPayCollection.form.orderCode = this.orderCode;
              this.$axios.post("/app/api/heshunbao/submitPolicyCompanyPay", this.companyPayCollection.form).then(() => {
                this.videoSave(res)
                this.loading = false;
              }).catch(error => {
                this.$message.error(error.message);
              })
            }
            //this.videoSave(res)
            // const orderCode = res.data.orderCode;
            // this.$router.push({ name: "pay", params: { orderCode } });

          })
          .catch(err => {
            this.$message.error(err.message);
            this.loading = false;
          });
      }
    },
    submitCompany(res){
      this.videoSave(res);
    },
    videoSave(result){
      const json = {
        monitorCode: this.monitorCode,
        monitorOrder:'1',
        monitorName:'投保流程',
        startTime:this.$miment().format("YYYY-MM-DD hh:mm:ss"),
        endTime:'',
        monitorContent:this.rrweb
      }
      this.$vAxios.post('/reception/saveMonitor',json).then(() => {
        this.$vAxios.post('/reception/savePolicy',{
          orderId:result.data.orderId,
          monitorCode: this.monitorCode
        }).then(() => {
          if(this.payType == 0){
            window.location.href = result.data.payUrl;
          }else{
            this.$router.push({
              path:'/insure/downPay',
              query:{
                param:window.btoa(JSON.stringify(result.data))
              }
            })
          }
        })
      }).catch(err => {
        this.$message.error(err.message);
      });
    },
    transformToEntity() {
      return {
        userId:this.user.id,
        productId: '2016',
        payType:this.payType,
        applicantEEstablishTime:this.form.applicantEEstablishTime,
        applicantEProvince:this.form.applicantEProvince.value,
        applicantEInstitutionType:this.form.applicantEInstitutionType,
        applicantEAddress:this.form.applicantEAddress,
        productPlanId: this.form.productPlanId,
        startDate: this.form.effectBeginDate,
        insurancePeriod: this.form.effectDuration >= 12?1:this.form.effectDuration,
        insurancePeriodUnit: this.form.effectDuration >= 12?3:2,
        amount: this.form.amount,
        applicantName: this.form.companyName,
        applicantIdentifyType: this.form.companyCardType,
        applicantIdentifyNumber: this.form.companyCardNo,
        contactName: this.form.contactName,
        contactEmail: this.form.contactEmail,
        officePhone: this.form.contactPhoneNumber,
        planList: this.planList,
        insuredList: this.employees.map(item => {
          return {
            name: item.name,
            identifyNumber: item.idCard,
            mobile: item.phone,
            jobCategory: item.category.code,
            jobName: item.category.name,
            jobLevel: item.category.level
          };
        })
      };
    },
    onUploadSuccess(file) {
      this.form.businessLicenseFile = file;
    },
    waringData(res){
      if (res.warningCount > 0){
        this.birthdayWarningCount = res.warningCount;
        this.birthdayWarningData = res.warningBirthdayList;
      }
    }
  }
};
</script>


<style lang="scss">
$form-item-left-width: 294px;
$form-item-label-width: 94px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
  .attention{
    color:$primary-color
  }
  .check-box-div{
    display: flex;
    flex-flow: row;
    width: 220px;
    margin-top: 10px;
  }
  .must-tap {
          color: red;
          margin-right: 3px;
        }
.notice-div{
  display: flex;
  flex-flow: column;
}
.p-insure {
  .insure-card {
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item {
        label {
          width: $form-item-label-width!important;
          text-align: right;
        }
      }
      .form-item-left {
        width: $form-item-left-width!important;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 5px;
        height: 50px;
      }
    }
  }
  .font-primary{
    color: #dd122a !important;
  }
  .form-item-center{
    position: relative;
    width: 200px;
    .form-item-center-radio{
      position: relative;
      width: 100%;
      margin-top: 0;
      .form-item-center-radio-item{
        width: 70px;
        height: 35px;
        position: absolute;
        margin-top: 0;
      }
      .form-item-center-radio-item:nth-child(2){
        left: 80px;
      }
    }
  }
  .v-container-form {
    padding: 30px;
    p{
      color: #dd122a !important;
      font-size: 13px;
      text-align: center;
    }
  }
}
</style>
